<template>
  <div v-if="isLoggedIn && dashboardNotifications.length > 0">
    <div
      v-for="notification in dashboardNotifications"
      class="alert alert-info alert-dismissible fade in"
      role="alert"
    >
      <button
        v-if="!inDeletionGuardList(notification.id)"
        type="button"
        class="close"
        aria-label="Close"
        @click="closeNotifications(notification.id)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-else class="close">
        <span class="btn-loading btn-sm" />
      </div>
      <small class="text-muted float-right notification-date">{{ notification.created_at | formatDate('M/d/yyyy h:mm a') }}</small>
      <div class="notification-message" v-html="$sanitize(linkify(notification.message))" />
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import { format as f, parseISO } from 'date-fns';
  import linkifyStr from 'linkify-string';

  export default {
    name: "DashboardNotifications",
    filters: {
      formatDate(date, format) {
        return f(parseISO(date), format);
      }
    },
    data() {
      return {
        deleting: []
      }
    },
    computed: {
      ...mapState(['dashboardNotifications']),
      ...mapGetters(['isLoggedIn']),
    },
    methods: {
      async closeNotifications(notification_id) {
        this.addToDeletionGuard(notification_id);
        try {
          await this.$store.dispatch('DISMISS_NOTIFICATION', notification_id);
        } catch (err) {
          // ignore error
        }
        this.removeDeletionGuard(notification_id);
      },
      addToDeletionGuard(notification_id) {
        if (!this.inDeletionGuardList(notification_id)) {
          this.deleting.push(notification_id);
        }
      },
      removeDeletionGuard(notification_id) {
        var index = this.deleting.indexOf(notification_id);
        if (index > -1) {
          this.deleting.splice(index, 1);
        }
      },
      inDeletionGuardList (notification_id) {
        return this.deleting.includes(notification_id);
      },
      linkify(message) {
        return linkifyStr(message, { target: { url: null }});
      }
    },
  }
</script>

<style scoped>
  .notification-date {
    padding: 2px 0 0 4px;
  }
</style>
